<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 275 50.26"
        fill="currentColor"
    >
        <path
            d="M18.62,43.74H8.09l2.54-2.54V10.26h7.99l2.48,2.53v28.41l-2.48,2.54ZM5.77,5.94L1.45,10.26h6.86l-2.54,2.53v30.95l-4.32,4.32H20.94l5.02-5.03V10.96l-5.02-5.02H5.77Z"
        />
        <path
            d="M37.57,26.19V10.26h6.37l2.49,2.53v8.7l-2.49,2.54h-4.21l-2.16,2.16Zm13.72,15.01v-12.15l-2.86-2.86,2.86-2.87V10.96l-5.02-5.02h-13.55l-4.32,4.32h6.86l-2.54,2.53v30.95l-4.32,4.32h9.18l3.78-4.32h-6.32l2.54-2.54v-12.85h6.37l2.49,2.53v12.86l-4.32,4.32h9.18l4.32-4.32h-6.86l2.54-2.54Z"
        />
        <polygon
            points="66.95 10.26 71.27 5.94 62.09 5.94 57.77 10.26 64.57 10.26 62.09 12.74 62.09 43.74 57.77 48.06 66.95 48.06 71.27 43.74 64.41 43.74 66.95 41.2 66.95 10.26"
        />
        <path
            d="M87.9,24.84h-4.21l-2.16,2.16V10.26h6.37l2.49,2.53v9.51l-2.49,2.54Zm-11.23-18.9l-4.32,4.32h6.86l-2.54,2.53v30.95l-4.32,4.32h9.18l4.32-4.32h-6.86l2.54-2.54v-12.04h8.69l5.02-5.03V10.96l-5.02-5.02h-13.55Z"
        />
        <polygon
            points="111.44 10.26 119.38 10.26 116.84 12.79 116.84 37.96 111.12 43.74 108.91 43.74 106.37 41.2 106.37 10.2 110.63 5.94 101.45 5.94 97.13 10.26 104.05 10.26 101.51 12.79 101.51 43.03 106.53 48.06 113.44 48.06 121.7 39.79 121.7 10.26 126.02 5.94 116.84 5.94 111.44 10.26"
        />
        <polygon
            points="135.74 28.72 143.36 28.72 147.68 24.4 137.9 24.4 135.74 26.56 135.74 10.26 146.33 10.26 150.65 5.94 130.88 5.94 126.56 10.26 133.37 10.26 130.88 12.74 130.88 43.74 126.56 48.06 145.9 48.06 150.22 43.74 133.21 43.74 135.74 41.2 135.74 28.72"
        />
        <path
            d="M160.91,26.19V10.26h6.37l2.48,2.53v8.7l-2.48,2.54h-4.21l-2.16,2.16Zm13.72,15.01v-12.15l-2.86-2.86,2.86-2.87V10.96l-5.02-5.02h-13.55l-4.32,4.32h6.86l-2.54,2.53v30.95l-4.32,4.32h9.18l3.78-4.32h-6.32l2.54-2.54v-12.85h6.37l2.48,2.53v12.86l-4.32,4.32h9.18l4.32-4.32h-6.86l2.54-2.54Z"
        />
        <polygon
            points="196.55 24.03 188.72 24.03 186.23 21.49 186.23 12.79 188.72 10.26 193.09 10.26 196.76 13.98 196.76 19.22 201.08 14.9 201.08 5.18 197.25 9.01 194.11 5.94 186.39 5.94 181.37 10.96 181.37 23.32 186.39 28.35 194.22 28.35 196.71 30.88 196.71 41.2 194.22 43.74 189.96 43.74 186.28 40.01 186.28 34.77 181.97 39.09 181.97 48.81 185.85 44.92 188.93 48.06 196.55 48.06 201.57 43.03 201.57 29.05 196.55 24.03"
        />
        <polygon
            points="214.26 10.26 218.58 5.94 209.4 5.94 205.08 10.26 211.88 10.26 209.4 12.74 209.4 43.74 205.08 48.06 214.26 48.06 218.58 43.74 211.72 43.74 214.26 41.2 214.26 10.26"
        />
        <polygon
            points="240.93 10.26 245.25 5.94 222.36 5.94 218.04 10.26 231.43 10.26 228.94 12.74 228.94 43.74 224.62 48.06 233.8 48.06 238.12 43.74 231.27 43.74 233.8 41.2 233.8 10.26 240.93 10.26"
        />
        <polygon
            points="260.05 10.26 267.18 10.26 264.37 13.06 264.37 19.33 259.18 24.57 258.48 24.57 253.3 19.33 253.3 10.26 253.35 10.26 257.67 5.94 248.49 5.94 244.17 10.26 251.25 10.26 248.44 13.06 248.44 21.16 256.48 29.21 256.48 43.79 252.22 48.06 261.4 48.06 265.72 43.74 258.81 43.74 261.34 41.2 261.34 29.05 269.23 21.16 269.23 10.26 273.55 5.94 264.37 5.94 260.05 10.26"
        />
    </svg>
</template>
